import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import CardRange from 'components/atoms/GefMui/CardRange';
import startupCurve from 'features/views/campaignSettings/startupCurve';
import { fromIsoDate } from 'utils';

export const WeekCard = ({ weekPosition, weekId }) => {
	const dispatch = useDispatch();

	const week = useSelector((state) => startupCurve.selectors.getWeekById(state, weekId));
	const isWeekIncorrect = useSelector(startupCurve.selectors.getIsWeekIncorrect(weekId));
	const type = isWeekIncorrect ? 'error' : 'info';

	const handleEffectivityChange = useCallback(
		(effectivity) => {
			dispatch(startupCurve.actions.updateWeekEffectivity(week.weekId, effectivity));
		},
		[dispatch, week.weekId],
	);

	return (
		<CardRange
			type={type}
			tabIndex={weekPosition}
			text={`${getLabelMessage('startupCurve:week')} ${weekPosition}`}
			subText={`(${fromIsoDate(week.startDate)} - ${fromIsoDate(week.endDate)})`}
			value={`${week.effectivity}`}
			onChange={handleEffectivityChange}
		/>
	);
};
WeekCard.propTypes = {
	weekId: PropTypes.number,
	weekPosition: PropTypes.number,
};

export default WeekCard;
